import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import React from "react";
import Loading from "../../../../../../components/Loading/Loading";
import { useToastContext } from "../../../../../../contexts/ToastContext/ToastContext";
import useExtracoinInfo from "../../../../../../hooks/useExtracoinInfo";
import localeText from "../../../../../../locale";
import useConvertWalletValue from "../../hooks/useConvertWalletValue";

const ConvertExtraCoinToWalletModal = ({
  conversion,
  onSuccessProps,
  openModal,
  visible,
  closeModal,
}) => {
  const { showErrorToast, showSuccessToast } = useToastContext();
  const {
    extracoinInfo,
    isLoading: isLoadingExtracoinInfo,
    setRetryFetch: setRetryFetchExtracoinInfo,
  } = useExtracoinInfo();

  const { conversionAmount, setConversionAmount, convertToWallet, isLoading } =
    useConvertWalletValue({
      conversion,
      onError: (code) => showErrorToast({ code }),
      onErrorConversionIsZero: () => showErrorToast({ detail: "errorConversionIsZero" }),
      onSuccess: () => {
        onSuccessProps();
        showSuccessToast({ detail: "successConversion" });
        setRetryFetchExtracoinInfo(true);
        setConversionAmount("");
        closeModal();
      },
      onErrorExpiredConversion: () => showErrorToast({ detail: "errorExpiredConversion" }),
    });

  return (
    <>
      <Button onClick={openModal}>{localeText("convert")}</Button>
      <Dialog
        className="mx-2"
        header={localeText("convertExtracoinToWallet")}
        visible={visible}
        style={{ width: "30vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        onHide={closeModal}
      >
        <div className="m-5 flex flex-column gap-4">
          <div>
            <p>
              {localeText("balance")}
              {isLoadingExtracoinInfo ? (
                <Loading disableMargin />
              ) : (
                ` Extracredit: ${extracoinInfo.currency} ${extracoinInfo.balance}`
              )}
            </p>
          </div>
          <InputNumber
            className="w-full"
            value={conversionAmount}
            locale="en-US"
            minFractionDigits={2}
            onValueChange={(e) => setConversionAmount(e.value)}
          />
          <Button
            className="w-min ml-auto md:text-base text-xs flex justify-content-center align-items-center gap-2"
            onClick={convertToWallet}
            disabled={isLoading}
            size="small"
          >
            {isLoading && <Loading disableMargin />}
            {localeText("convert")}
          </Button>
        </div>
      </Dialog>
    </>
  );
};

export default ConvertExtraCoinToWalletModal;
